import React from "react";
import { useTranslation } from "react-i18next";
import { RiArrowDownSLine } from "react-icons/ri";
import { Link } from "react-router-dom";

import LanguageSwitcher from "./LanguageSwitcher";

const ResourceIcon = ({ icon: Icon }) =>
  Icon ? <Icon className="mt-0.5 shrink-0 text-base text-sky-500" /> : null;

const MobileMenu = ({
  isOpen,
  mobileDropdown,
  navigationOptions,
  onClose,
  onToggleDropdown,
  renderNavLink,
  resourceIcons,
}) => {
  const { t } = useTranslation("navigation");

  return (
    <div
      className={`fixed inset-x-0 bottom-0 top-16 z-40 bg-white transition-all duration-300 ease-out lg:hidden ${
        isOpen
          ? "pointer-events-auto translate-y-0 opacity-100"
          : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <div className="flex h-[92vh] flex-col bg-white px-4 pb-6 pt-4 sm:px-6">
        <div className="flex-1 overflow-y-auto">
          <nav className="flex flex-col gap-2">
            {navigationOptions.map(([key, value]) => {
              const hasItems = value.ITEMS && value.ITEMS.length > 0;
              const isActiveDropdown = mobileDropdown === key;
              const baseClasses =
                "flex w-full items-center justify-between rounded-2xl px-4 py-3 text-left text-base font-medium text-slate-700 transition hover:bg-slate-50 hover:text-sky-600";

              if (!hasItems) {
                return (
                  <div key={key}>
                    {renderNavLink(value, baseClasses, onClose)}
                  </div>
                );
              }

              return (
                <div className="rounded-3xl" key={key}>
                  <button
                    aria-expanded={isActiveDropdown}
                    className={`${baseClasses} ${
                      isActiveDropdown ? "bg-slate-50 text-sky-600" : ""
                    }`}
                    onClick={() => onToggleDropdown(key)}
                    type="button"
                  >
                    <span>{t(value.LABEL)}</span>
                    <RiArrowDownSLine
                      className={`text-lg transition ${
                        isActiveDropdown ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {isActiveDropdown ? (
                    <div className="mt-2 space-y-2 px-6 pb-2">
                      {value.ITEMS.map(([itemKey, item]) => (
                        <Link
                          className="flex items-start gap-3 rounded-2xl px-4 py-3 text-sm text-slate-600 transition hover:bg-slate-50 hover:text-sky-600"
                          key={itemKey}
                          onClick={onClose}
                          to={item.PATH}
                        >
                          <ResourceIcon icon={resourceIcons[item.ICON]} />
                          <span>{t(item.LABEL)}</span>
                        </Link>
                      ))}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </nav>
        </div>

        <div className="mt-6 border-t border-slate-200 pt-4">
          <div className="flex flex-row items-center justify-between">
            <LanguageSwitcher
              align="left"
              className="w-fit"
              menuPosition="top"
            />

            <a
              className="text-sm font-medium text-sky-600 transition"
              href="https://www.comp.nus.edu.sg/~dbsystem/"
              rel="noopener noreferrer"
              target="_blank"
            >
              {t("dbSystem")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
